// Shared by ScheduleConfigPanel.js and CalendarEntryEditModal.js — kept in
// its own module (rather than exported from ScheduleConfigPanel.js) so the
// two don't form a circular import (ScheduleConfigPanel.js also imports
// CalendarEntryEditModal.js, to render it).
export function formatCalendarDate(date: string | Date): string {
  // SchoolCalendarResponse.date arrives over JSON as an ISO string.
  if (typeof date === "string") return date.slice(0, 10);

  // Fallback for an actual Date object — build YYYY-MM-DD from local date
  // parts (not toISOString(), which shifts to UTC and can roll the date
  // across a timezone boundary).
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
